export const categoryKeyMap: Record<string, string> = {
  for_you: 'For You',
  cat: 'Katze',
  dog: 'Hund',
  bird: 'Vogel',
  small_animal: 'Kleintier',
  aqua: 'Aquaristik',
  terra: 'Terraristik',
}
